var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.045,
    cy: 44.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.045,
    cy: 34.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.045,
    cy: 8.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.045,
    cy: 10.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.045,
    cy: 15.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.045,
    cy: 24.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.045,
    cy: 34.045,
    r: 3.045,
    fill: "#825BD9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.045,
    cy: 44.045,
    r: 3.045,
    fill: "#C177FB",
    fillOpacity: 0.08
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.045,
    cy: 53.045,
    r: 3.045,
    fill: "#C177FB",
    fillOpacity: 0.15
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.045,
    cy: 58.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.25
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.045,
    cy: 60.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.045,
    cy: 58.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.35
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.045,
    cy: 53.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.045,
    cy: 24.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.55
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.045,
    cy: 15.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.6
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.045,
    cy: 10.045,
    r: 3.045,
    fill: "#825BD9",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerIcn);
export default __webpack_public_path__ + "static/media/spinner-icn.2661f849be3de7ee468927e43b9f764c.svg";
export { ForwardRef as ReactComponent };